<script>
import BaseConfig from './base-config.vue';

export default {
  name: 'DIDAdd2Cart',
  extends: BaseConfig,
};
</script>
